(function () {
	'use strict';
	angular.module('app.setup')
		.controller('procurementSetup', procurementSetup);

	procurementSetup.$inject = ['$rootScope', '$scope', '$timeout', '$filter', '$q', '$uibModal', 'customerSettingService',
		'factorySettingService', 'procurementService', 'storeService', 'sqlSnippetService', 'ENVIRONMENT', '$experiments'];

	function procurementSetup($rootScope, $scope, $timeout, $filter, $q, $uibModal, customerSettingService, factorySettingService,
			procurementService, storeService, sqlSnippetService, ENVIRONMENT, $experiments) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;

		vm.isSuperAdmin = $rootScope.authz.isSuperAdmin(adminConfig.factory.id);
		vm.isLeanDNAAdmin = $rootScope.authz.isLeanDNAAdmin(adminConfig.factory.id);
		vm.isLeanDNACustomerAdmin = $rootScope.authz.isLeanDNACustomerAdmin(adminConfig.factory.id);
		vm.data = {};
		vm.safetyCalcMethodChange = safetyCalcMethodChange;
		vm.excessCalcMethodChange = excessCalcMethodChange;
		vm.displaySaveConfirmModal = displaySaveConfirmModal;
		vm.save = save;
		vm.currency = globalConfig.user.authFacts[adminConfig.factory.id].currencySymbol.trim();
		vm.snippets = null;
		vm.currentSqlSnippet = null;
		vm.showAdvanced = vm.isSuperAdmin || (ENVIRONMENT.CURRENT !== ENVIRONMENT.PRODUCTION && vm.isLeanDNAAdmin);
		vm.customerName = adminConfig.customer.name;
		vm.showForceFutureForForecast = $experiments.isEnabled('forecast-force-future-demand');
		vm.showForwardDemandDOI = $experiments.isEnabled('forward-demand-doi');

		vm.posToIncludeInClearToBuildWindowChoices = [
			{
				display: 'Exclude all Past Due and Open POs',
				value: 'None'
			},
			{
				display: 'Include POs with Tracking Numbers only',
				value: 'POsWithTrackingNumber'
			}
		];

		vm.serviceLevelOptions = [{
			'display': '95.0%',
			'value': 1.645
		}, {
			'display': '97.5%',
			'value': 1.960
		}, {
			'display': '99.0%',
			'value': 2.326
		}, {
			'display': '99.5%',
			'value': 2.576
		}, {
			'display': '99.9%',
			'value': 3.090
		}];

		vm.fieldForfirstImpactedOrderInSBIOptions = [
			{
				'display': 'Order Number',
				'value': 'orderNumber'
			},{
				'display': 'Production Order',
				'value': 'productionOrder'
			}
		];

		var settingsList = [
			'FY_INVENTORY_TARGET',
			'PROCUREMENT_A_ITEM_PERCENTAGE',
			'PROCUREMENT_B_ITEM_PERCENTAGE',
			'PROCUREMENT_BURNOFF_ENABLE_EXPERIMENT',
			'PROCUREMENT_C_ITEM_PERCENTAGE',
			'PROCUREMENT_CARRYING_COST',
			'PROCUREMENT_COST_TO_PLACE_ORDER',
			'PROCUREMENT_USE_ORDER_INTERVAL_FOR_LOGICAL_LEADTIME',
			'PROCUREMENT_DAYS_OF_INVENTORY_TARGET',
			'PROCUREMENT_EXCESS_CALC_TYPE',
			'PROCUREMENT_EXCESS_POLICY_IN_DAYS',
			'PROCUREMENT_FIELD_FOR_FIRST_IMPACTED_ORDER_IN_SBI',
			'PROCUREMENT_INCLUDE_PO_FOR_MINMAX_PARTS',
			'PROCUREMENT_INCLUDE_PRS_IN_ONORDER_INVENTORY_FLAG',
			'PROCUREMENT_INCLUDE_PUR_REQ_IN_BURNOFF',
			'PROCUREMENT_LEAD_TIME_THRESHOLD',
			'PROCUREMENT_MAX_LEAD_TIME_BEFORE_USING_IN_DAYS',
			'PROCUREMENT_METHOD_TO_DETERMINE_ORDER_QTY_TYPE',
			'PROCUREMENT_MAX_COEFFICIENT_OF_VARIABILITY_FOR_X_ITEMS',
			'PROCUREMENT_MAX_COEFFICIENT_OF_VARIABILITY_FOR_Y_ITEMS',
			'PROCUREMENT_MINIMUM_PO_VALUE',
			'PROCUREMENT_MULTIPLE_OF_LEADTIME_THRESHOLD',
			'PROCUREMENT_NO_OF_DAYS_IN_EXCESS_TO_SELL_REPORT',
			'PROCUREMENT_PEG_RECEIPTS_USING_SCHEDULE_LINE',
			'PROCUREMENT_REQUIREMENT_SOURCE_FOR_CALCULATIONS',
			'PROCUREMENT_BUCKETS_IN_PERIOD',
			'PROCUREMENT_WEEKS_IN_PAST_DEMAND_CALCULATIONS',
			'PROCUREMENT_GENERATE_FORECAST_DATA_FROM_PAST_DEMAND',
			'PROCUREMENT_GENERATE_FORECAST_START_WEEK',
			'PROCUREMENT_GENERATE_FORECAST_END_WEEK',
			'PROCUREMENT_GENERATE_FORECAST_ITEM_SQLSNIPPETID',
			'PROCUREMENT_SAFETY_DAYS',
			'PROCUREMENT_SAFETY_FACTOR',
			'PROCUREMENT_SAFETY_STOCK_TYPE_IN_TARGET_INVENTORY',
			'PROCUREMENT_SUBTRACT_SAFETY_STOCK_FROM_EXCESS_FLAG',
			'PROCUREMENT_SUBTRACT_REQUIREMENTS_FROM_EXCESS_FOR_ROP',
			'PROCUREMENT_USE_SAFETY_FACTOR_OR_STANDARD_DEVIATION',
			'PROCUREMENT_USE_HISTORICAL_USAGE_WHEN_GREATER',
			'STRETCH_INVENTORY_TARGET',
			'EXCESS_TO_SELL_EXCLUDE_FROM_OPPORTUNITIES',
			'PO_TO_ACTION_MONTHLY_NUM_WEEKS_FOR_REQS',
			'PROCUREMENT_INCLUDE_RECEIVING_AND_PROCUREMENT_LEADTIME_IN_LOB',
			'PROCUREMENT_OVERRIDE_ERP_MIN_MAX_EFFECTIVE_DATE',
			'PROCUREMENT_FINISHED_GOODS_PAST_WEEKS_OF_ORDERS',
			'PROCUREMENT_FINISHED_GOODS_FUTURE_WEEKS_OF_ORDERS',
			'SHORTAGE_CLEAR_TO_BUILD_WINDOW',
			'PROCUREMENT_IGNORE_SUPPLY_FOR_ROP_IN_BURNOFF',
			'POS_TO_INCLUDE_IN_CLEAR_TO_BUILD_WINDOW',
			'PROCUREMENT_USE_FUTURE_DEMAND_WHEN_FORECAST_PRESENT',
			'USE_FORWARD_ONLY_DEMAND_FOR_FORWARD_DOI',
			'FORWARD_DOI_WINDOW'
		];

		init();

		function init() {
			vm.data.itemForDetailedLog = '';
			customerSettingService.getCustomerSettings(['EnableFGAnalytics'])
				.then(function (data) {
					vm.data.isFgEnabled = data['EnableFGAnalytics'];
				});
			factorySettingService.getFactorySettings(settingsList, adminConfig.factory.id)
				.then(function (settings) {

					// Use Historical Usage if greater than Future ADD
					vm.data.useHistoricalUsage = settings.PROCUREMENT_USE_HISTORICAL_USAGE_WHEN_GREATER;
					vm.data.useFutureDemandWhenForecastPresent = settings.PROCUREMENT_USE_FUTURE_DEMAND_WHEN_FORECAST_PRESENT;

					// Requirement Calculation
					switch (settings.PROCUREMENT_REQUIREMENT_SOURCE_FOR_CALCULATIONS) { 
					case 'Past':
						vm.data.requirementCalculationBasedOn = 'Past Demand Only';
						break;
					case 'Future':
						if (vm.data.useHistoricalUsage) { 
							vm.data.requirementCalculationBasedOn = 'Greatest between Past and Future Demand';
							break;
						}
						vm.data.requirementCalculationBasedOn = 'Future Demand Only';
						break;
					case 'PastAndFuture':
						vm.data.requirementCalculationBasedOn = 'A combination of Past & Future';
						break;
					}

					// Requirement Period
					vm.data.requirementPeriod = settings.PROCUREMENT_BUCKETS_IN_PERIOD;
					vm.data.requirementPeriodPastDemand = settings.PROCUREMENT_WEEKS_IN_PAST_DEMAND_CALCULATIONS;

					// Forecasting
					vm.data.forecastUsingPastData = settings.PROCUREMENT_GENERATE_FORECAST_DATA_FROM_PAST_DEMAND;
					vm.data.forecastStartWeek = settings.PROCUREMENT_GENERATE_FORECAST_START_WEEK;
					vm.data.forecastEndWeek = settings.PROCUREMENT_GENERATE_FORECAST_END_WEEK;
					vm.data.generateForecastDataItemSQLSnippetId = settings.PROCUREMENT_GENERATE_FORECAST_ITEM_SQLSNIPPETID;
					getSnippets(settings.PROCUREMENT_GENERATE_FORECAST_ITEM_SQLSNIPPETID);

					// Include PR in On Order
					vm.data.prInOnOrder = settings.PROCUREMENT_INCLUDE_PRS_IN_ONORDER_INVENTORY_FLAG;

					// Peg using schedule lines
					vm.data.scheduleLinePegging = settings.PROCUREMENT_PEG_RECEIPTS_USING_SCHEDULE_LINE;

					// Fy Target
					vm.data.fyTarget = $filter('number')(settings.FY_INVENTORY_TARGET) === '0' ? '' : parseFloat(settings.FY_INVENTORY_TARGET);
					// Days of Inventory Target
					vm.data.daysOfInventoryTarget = settings.PROCUREMENT_DAYS_OF_INVENTORY_TARGET;
					// Stretch FY Target
					vm.data.stretchFyTarget = $filter('number')(settings.STRETCH_INVENTORY_TARGET) === '0' ? '' : parseFloat(settings.STRETCH_INVENTORY_TARGET);
					// Method for PO Quantity
					if (settings.PROCUREMENT_METHOD_TO_DETERMINE_ORDER_QTY_TYPE === 'UseABCOrderFrequency') {
						vm.data.methodForPoQuantity = 'Use ABC Order Frequency';
					} else if (settings.PROCUREMENT_METHOD_TO_DETERMINE_ORDER_QTY_TYPE === 'UseLeadtimeBasedOrderFrequency') {
						vm.data.methodForPoQuantity = 'Use Lead Time Based Order Frequency';
					}
					// Include PR in Burn-off
					vm.data.prInBurnoff = settings.PROCUREMENT_INCLUDE_PUR_REQ_IN_BURNOFF;
					// Ignore Supply for ROP Items
					vm.data.ignoreSupplyForRopInBurnoff = settings.PROCUREMENT_IGNORE_SUPPLY_FOR_ROP_IN_BURNOFF;
					// Include PO for Min-Max Parts
					vm.data.poMinMaxParts = settings.PROCUREMENT_INCLUDE_PO_FOR_MINMAX_PARTS;
					// Field for first impacted order in SBI
					vm.data.fieldForfirstImpactedOrderInSBI = settings.PROCUREMENT_FIELD_FOR_FIRST_IMPACTED_ORDER_IN_SBI;

					// Use new calculation for burnoff
					vm.data.burnoffEnableExperiment = settings.PROCUREMENT_BURNOFF_ENABLE_EXPERIMENT;
					// If true, logical lead time = min(lead time, order interval). Otherwise, logical lead time = lead time
					vm.data.useOrderIntervalForLogicalLeadTime = settings.PROCUREMENT_USE_ORDER_INTERVAL_FOR_LOGICAL_LEADTIME;
					
					// LOB supply exclusion window
					vm.data.shortageClearToBuildWindow = settings.SHORTAGE_CLEAR_TO_BUILD_WINDOW;
					vm.data.posToIncludeInClearToBuildWindow = settings.POS_TO_INCLUDE_IN_CLEAR_TO_BUILD_WINDOW;

					// Add Receiving Time and Procurement Lead time for LOB generation
					vm.data.includeReceivingAndProcurementLeadtimeInLOB = settings.PROCUREMENT_INCLUDE_RECEIVING_AND_PROCUREMENT_LEADTIME_IN_LOB;

					// Override the ERP value for minmax effective date with the value that we calculate for minmax effective date
					vm.data.overrideErpMinMaxEffectiveDate = settings.PROCUREMENT_OVERRIDE_ERP_MIN_MAX_EFFECTIVE_DATE;

					// A Items
					vm.data.aItems = {};
					vm.data.aItems.pq = settings.PROCUREMENT_A_ITEM_PERCENTAGE;

					// B Items
					vm.data.bItems = {};
					vm.data.bItems.pq = settings.PROCUREMENT_B_ITEM_PERCENTAGE;

					// C Items
					vm.data.cItems = {};
					vm.data.cItems.pq = settings.PROCUREMENT_C_ITEM_PERCENTAGE;

					// XYZ Items
					vm.data.xItems = settings.PROCUREMENT_MAX_COEFFICIENT_OF_VARIABILITY_FOR_X_ITEMS;
					vm.data.yItems = settings.PROCUREMENT_MAX_COEFFICIENT_OF_VARIABILITY_FOR_Y_ITEMS;

					// Use ERP Safety Stock
					if (settings.PROCUREMENT_SAFETY_STOCK_TYPE_IN_TARGET_INVENTORY === 'Analysis') {
						vm.data.erpSafetyStock = false;
					} else {
						vm.data.erpSafetyStock = true;
					}

					// LeanDNA Calculation Method
					if (settings.PROCUREMENT_USE_SAFETY_FACTOR_OR_STANDARD_DEVIATION === 'StandardDeviation') {
						vm.data.calculationMethod = 'Standard Deviation';
					} else if (settings.PROCUREMENT_USE_SAFETY_FACTOR_OR_STANDARD_DEVIATION === 'SafetyFactor') {
						vm.data.calculationMethod = 'Safety Factor';
					} else if (settings.PROCUREMENT_USE_SAFETY_FACTOR_OR_STANDARD_DEVIATION === 'SafetyDays') {
						vm.data.calculationMethod = 'Safety Days';
					} else if (settings.PROCUREMENT_USE_SAFETY_FACTOR_OR_STANDARD_DEVIATION === 'SafetyDaysPlusStandardDeviation') {
						vm.data.calculationMethod = 'Standard Deviation + Days';
					} else if (settings.PROCUREMENT_USE_SAFETY_FACTOR_OR_STANDARD_DEVIATION === 'SafetyDaysPlusSafetyFactor') {
						vm.data.calculationMethod = 'Safety Factor + Days';
					}
					// Safety Factor
					vm.data.safetyFactor = settings.PROCUREMENT_SAFETY_FACTOR * 100;
					// Safety Days
					vm.data.safetyDays = settings.PROCUREMENT_SAFETY_DAYS;

					// Excess Calculation
					if (settings.PROCUREMENT_EXCESS_CALC_TYPE === 'Leadtime') {
						vm.data.excessCalculation = 'Use Multiple of Lead Time';
					} else if (settings.PROCUREMENT_EXCESS_CALC_TYPE === 'Number_of_Days') {
						vm.data.excessCalculation = 'Use Number of Days';
					} else if (settings.PROCUREMENT_EXCESS_CALC_TYPE === 'Leadtime_and_Days') {
						vm.data.excessCalculation = 'Use Multiple of Lead Time and Days';
					} else if (settings.PROCUREMENT_EXCESS_CALC_TYPE === 'Amount_Over_Total_Requirements') {
						vm.data.excessCalculation = 'Amount Over Total Requirements';
					} else if (settings.PROCUREMENT_EXCESS_CALC_TYPE === 'Amount_Over_3_Times_Annual_Requirements') {
						vm.data.excessCalculation = 'Amount Over 3 Times Annual Requirements';
					}
					// Subtract from Excess
					vm.data.subtractSafetyFromExcess = settings.PROCUREMENT_SUBTRACT_SAFETY_STOCK_FROM_EXCESS_FLAG;
					vm.data.subtractRequirementsFromExcessForRop = settings.PROCUREMENT_SUBTRACT_REQUIREMENTS_FROM_EXCESS_FOR_ROP;
					vm.data.excessToSellExcludeFromOpportunities = settings.EXCESS_TO_SELL_EXCLUDE_FROM_OPPORTUNITIES;
					
					// Excess Policy (Days)
					vm.data.excessPolicy = settings.PROCUREMENT_EXCESS_POLICY_IN_DAYS;
					// Multiple of Lead Time Threshold
					vm.data.multipleLeadTimeThreshold = settings.PROCUREMENT_MULTIPLE_OF_LEADTIME_THRESHOLD;
					// Max Lead Time before using Days
					vm.data.maxLeadBeforeDays = settings.PROCUREMENT_MAX_LEAD_TIME_BEFORE_USING_IN_DAYS;

					// Lead Time Threshold
					vm.data.leadTime = settings.PROCUREMENT_LEAD_TIME_THRESHOLD;

					// Carrying Cost
					vm.data.carryingCost = settings.PROCUREMENT_CARRYING_COST;
					// Cost to place one PO
					vm.data.costToPlacePo = settings.PROCUREMENT_COST_TO_PLACE_ORDER;
					// Minimum PO Value
					vm.data.minPoValue = settings.PROCUREMENT_MINIMUM_PO_VALUE;

					// POs to Action Monthly
					vm.data.numWeeksForMonthlyPoReqs = settings.PO_TO_ACTION_MONTHLY_NUM_WEEKS_FOR_REQS;

					// FG settings
					vm.data.fgPastWeeksOfOrders = settings.PROCUREMENT_FINISHED_GOODS_PAST_WEEKS_OF_ORDERS;
					vm.data.fgFutureWeeksOfOrders = settings.PROCUREMENT_FINISHED_GOODS_FUTURE_WEEKS_OF_ORDERS;

					// Forward DOI settings
					vm.data.useForwardOnlyDemandForForwardDOI = settings.USE_FORWARD_ONLY_DEMAND_FOR_FORWARD_DOI;
					vm.data.forwardDOIWindow = settings.FORWARD_DOI_WINDOW;

					if (settings.PROCUREMENT_NO_OF_DAYS_IN_EXCESS_TO_SELL_REPORT && settings.PROCUREMENT_NO_OF_DAYS_IN_EXCESS_TO_SELL_REPORT != -1) {
						vm.data.noOfDaysInExcessToSellReport = settings.PROCUREMENT_NO_OF_DAYS_IN_EXCESS_TO_SELL_REPORT;
					}

					safetyCalcMethodChange();
					excessCalcMethodChange();
				});
		}

		function save(run) {
			var settingsToSave = {};

			// Requirement Calculation
			settingsToSave.PROCUREMENT_USE_HISTORICAL_USAGE_WHEN_GREATER = 0;
			switch (vm.data.requirementCalculationBasedOn) { 
			case 'Past Demand Only':
				settingsToSave.PROCUREMENT_REQUIREMENT_SOURCE_FOR_CALCULATIONS = 'Past';
				break;
			case 'Future Demand Only':
				settingsToSave.PROCUREMENT_REQUIREMENT_SOURCE_FOR_CALCULATIONS = 'Future';
				break;
			case 'Greatest between Past and Future Demand':
				settingsToSave.PROCUREMENT_REQUIREMENT_SOURCE_FOR_CALCULATIONS = 'Future';
				settingsToSave.PROCUREMENT_USE_HISTORICAL_USAGE_WHEN_GREATER = 1;
				break;
			case 'A combination of Past & Future':
				settingsToSave.PROCUREMENT_REQUIREMENT_SOURCE_FOR_CALCULATIONS = 'PastAndFuture';
				break;
			}
			// Requirement Period
			settingsToSave.PROCUREMENT_BUCKETS_IN_PERIOD = vm.data.requirementPeriod;
			var defaultWeeks = 52;
			vm.data.requirementPeriodPastDemand = vm.data.requirementPeriodPastDemand || defaultWeeks;
			settingsToSave.PROCUREMENT_WEEKS_IN_PAST_DEMAND_CALCULATIONS = vm.data.requirementPeriodPastDemand;
			settingsToSave.PROCUREMENT_USE_FUTURE_DEMAND_WHEN_FORECAST_PRESENT = vm.data.useFutureDemandWhenForecastPresent;

			// Forecasting
			settingsToSave.PROCUREMENT_GENERATE_FORECAST_DATA_FROM_PAST_DEMAND = vm.data.forecastUsingPastData;
			settingsToSave.PROCUREMENT_GENERATE_FORECAST_START_WEEK = vm.data.forecastStartWeek;
			settingsToSave.PROCUREMENT_GENERATE_FORECAST_END_WEEK = vm.data.forecastEndWeek;
			settingsToSave.PROCUREMENT_GENERATE_FORECAST_ITEM_SQLSNIPPETID = vm.currentSqlSnippet.id;

			// Include PR in On Order
			settingsToSave.PROCUREMENT_INCLUDE_PRS_IN_ONORDER_INVENTORY_FLAG = vm.data.prInOnOrder;

			// Peg using schedule lines
			settingsToSave.PROCUREMENT_PEG_RECEIPTS_USING_SCHEDULE_LINE = vm.data.scheduleLinePegging;

			// Fy Target
			settingsToSave.FY_INVENTORY_TARGET = vm.data.fyTarget;
			// Days of Inventory Target
			if (vm.data.daysOfInventoryTarget) {
				settingsToSave.PROCUREMENT_DAYS_OF_INVENTORY_TARGET = vm.data.daysOfInventoryTarget;
			}


			// Stretch FY Target
			settingsToSave.STRETCH_INVENTORY_TARGET = vm.data.stretchFyTarget;
			// Method for PO Quantity
			if (vm.data.methodForPoQuantity === 'Use ABC Order Frequency') {
				settingsToSave.PROCUREMENT_METHOD_TO_DETERMINE_ORDER_QTY_TYPE = 'UseABCOrderFrequency';
			} else if (vm.data.methodForPoQuantity === 'Use Lead Time Based Order Frequency') {
				settingsToSave.PROCUREMENT_METHOD_TO_DETERMINE_ORDER_QTY_TYPE = 'UseLeadtimeBasedOrderFrequency';
			}
			// Include PR in Burn-off
			settingsToSave.PROCUREMENT_INCLUDE_PUR_REQ_IN_BURNOFF = vm.data.prInBurnoff;
			// Ignore Supply for ROP Items
			settingsToSave.PROCUREMENT_IGNORE_SUPPLY_FOR_ROP_IN_BURNOFF = vm.data.ignoreSupplyForRopInBurnoff;
			// Include PO for Min-Max Parts
			settingsToSave.PROCUREMENT_INCLUDE_PO_FOR_MINMAX_PARTS = vm.data.poMinMaxParts;
			// Field for first impacted order in SBI
			settingsToSave.PROCUREMENT_FIELD_FOR_FIRST_IMPACTED_ORDER_IN_SBI = vm.data.fieldForfirstImpactedOrderInSBI;
			
			// Use new calculation for burnoff
			settingsToSave.PROCUREMENT_BURNOFF_ENABLE_EXPERIMENT = vm.data.burnoffEnableExperiment;
			// If true, logical lead time = min(lead time, order interval). Otherwise, logical lead time = lead time
			settingsToSave.PROCUREMENT_USE_ORDER_INTERVAL_FOR_LOGICAL_LEADTIME = vm.data.useOrderIntervalForLogicalLeadTime;

			settingsToSave.SHORTAGE_CLEAR_TO_BUILD_WINDOW = vm.data.shortageClearToBuildWindow;
			settingsToSave.POS_TO_INCLUDE_IN_CLEAR_TO_BUILD_WINDOW = vm.data.posToIncludeInClearToBuildWindow;

			settingsToSave.PROCUREMENT_INCLUDE_RECEIVING_AND_PROCUREMENT_LEADTIME_IN_LOB = vm.data.includeReceivingAndProcurementLeadtimeInLOB;

			settingsToSave.PROCUREMENT_OVERRIDE_ERP_MIN_MAX_EFFECTIVE_DATE = vm.data.overrideErpMinMaxEffectiveDate;

			// A Items
			if (vm.data.aItems.pq) {
				settingsToSave.PROCUREMENT_A_ITEM_PERCENTAGE = vm.data.aItems.pq;
			}

			// B Items
			if (vm.data.bItems.pq) {
				settingsToSave.PROCUREMENT_B_ITEM_PERCENTAGE = vm.data.bItems.pq;
			}

			// C Items
			if (vm.data.cItems.pq) {
				settingsToSave.PROCUREMENT_C_ITEM_PERCENTAGE = vm.data.cItems.pq;
			}

			// X Items
			if (vm.data.xItems) {
				settingsToSave.PROCUREMENT_MAX_COEFFICIENT_OF_VARIABILITY_FOR_X_ITEMS = vm.data.xItems;
			}
			// Y Items
			if (vm.data.yItems) {
				settingsToSave.PROCUREMENT_MAX_COEFFICIENT_OF_VARIABILITY_FOR_Y_ITEMS = vm.data.yItems;
			}

			// Use ERP Safety Stock
			if (vm.data.erpSafetyStock) {
				settingsToSave.PROCUREMENT_SAFETY_STOCK_TYPE_IN_TARGET_INVENTORY = 'ERP';
			} else {
				settingsToSave.PROCUREMENT_SAFETY_STOCK_TYPE_IN_TARGET_INVENTORY = 'Analysis';
			}
			// LeanDNA Calculation Method
			if (vm.data.calculationMethod === 'Standard Deviation') {
				settingsToSave.PROCUREMENT_USE_SAFETY_FACTOR_OR_STANDARD_DEVIATION = 'StandardDeviation';
			} else if (vm.data.calculationMethod === 'Safety Factor') {
				settingsToSave.PROCUREMENT_USE_SAFETY_FACTOR_OR_STANDARD_DEVIATION = 'SafetyFactor';
			} else if (vm.data.calculationMethod === 'Safety Days') {
				settingsToSave.PROCUREMENT_USE_SAFETY_FACTOR_OR_STANDARD_DEVIATION = 'SafetyDays';
			} else if (vm.data.calculationMethod === 'Standard Deviation + Days') {
				settingsToSave.PROCUREMENT_USE_SAFETY_FACTOR_OR_STANDARD_DEVIATION = 'SafetyDaysPlusStandardDeviation';
			} else if (vm.data.calculationMethod === 'Safety Factor + Days') {
				settingsToSave.PROCUREMENT_USE_SAFETY_FACTOR_OR_STANDARD_DEVIATION = 'SafetyDaysPlusSafetyFactor';
			}
			// Safety Factor
			if (vm.data.safetyFactor) {
				settingsToSave.PROCUREMENT_SAFETY_FACTOR = vm.data.safetyFactor / 100;
			}
			// Safety Days
			if (vm.data.safetyDays) {
				settingsToSave.PROCUREMENT_SAFETY_DAYS = vm.data.safetyDays;
			}

			// Excess Calculation
			if (vm.data.excessCalculation === 'Use Multiple of Lead Time') {
				settingsToSave.PROCUREMENT_EXCESS_CALC_TYPE = 'Leadtime';
			} else if (vm.data.excessCalculation === 'Use Number of Days') {
				settingsToSave.PROCUREMENT_EXCESS_CALC_TYPE = 'Number_of_Days';
			} else if (vm.data.excessCalculation === 'Use Multiple of Lead Time and Days') {
				settingsToSave.PROCUREMENT_EXCESS_CALC_TYPE = 'Leadtime_and_Days';
			} else if (vm.data.excessCalculation === 'Amount Over Total Requirements') {
				settingsToSave.PROCUREMENT_EXCESS_CALC_TYPE = 'Amount_Over_Total_Requirements';
			} else if (vm.data.excessCalculation === 'Amount Over 3 Times Annual Requirements') {
				settingsToSave.PROCUREMENT_EXCESS_CALC_TYPE = 'Amount_Over_3_Times_Annual_Requirements';
			}
			// Subtract from Excess
			settingsToSave.PROCUREMENT_SUBTRACT_SAFETY_STOCK_FROM_EXCESS_FLAG = vm.data.subtractSafetyFromExcess;
			settingsToSave.PROCUREMENT_SUBTRACT_REQUIREMENTS_FROM_EXCESS_FOR_ROP = vm.data.subtractRequirementsFromExcessForRop;
			// Exclude this site from Excess to Sell opportunities at other sites
			settingsToSave.EXCESS_TO_SELL_EXCLUDE_FROM_OPPORTUNITIES = vm.data.excessToSellExcludeFromOpportunities;
			// Excess Policy (Days)
			if (vm.data.excessPolicy) {
				settingsToSave.PROCUREMENT_EXCESS_POLICY_IN_DAYS = vm.data.excessPolicy;
			}
			// Multiple of Lead Time Threshold
			if (vm.data.multipleLeadTimeThreshold) {
				settingsToSave.PROCUREMENT_MULTIPLE_OF_LEADTIME_THRESHOLD = vm.data.multipleLeadTimeThreshold;
			}
			// Max Lead Time before using Days
			if (vm.data.maxLeadBeforeDays) {
				settingsToSave.PROCUREMENT_MAX_LEAD_TIME_BEFORE_USING_IN_DAYS = vm.data.maxLeadBeforeDays;
			}

			// Lead Time Threshold
			if (vm.data.leadTime) {
				settingsToSave.PROCUREMENT_LEAD_TIME_THRESHOLD = vm.data.leadTime;
			}

			// Carrying Cost
			if (vm.data.carryingCost) {
				settingsToSave.PROCUREMENT_CARRYING_COST = vm.data.carryingCost;
			}
			// Cost to place one PO
			if (vm.data.costToPlacePo) {
				settingsToSave.PROCUREMENT_COST_TO_PLACE_ORDER = vm.data.costToPlacePo;
			}
			// Minimum PO Value
			if (vm.data.minPoValue) {
				settingsToSave.PROCUREMENT_MINIMUM_PO_VALUE = vm.data.minPoValue;
			}

			if (vm.data.noOfDaysInExcessToSellReport > 0) {
				settingsToSave.PROCUREMENT_NO_OF_DAYS_IN_EXCESS_TO_SELL_REPORT = vm.data.noOfDaysInExcessToSellReport;
			} else {
				settingsToSave.PROCUREMENT_NO_OF_DAYS_IN_EXCESS_TO_SELL_REPORT = -1;
			}

			if (vm.data.numWeeksForMonthlyPoReqs || vm.data.numWeeksForMonthlyPoReqs === 0) {
				settingsToSave.PO_TO_ACTION_MONTHLY_NUM_WEEKS_FOR_REQS = vm.data.numWeeksForMonthlyPoReqs;
			}
			if (vm.data.fgPastWeeksOfOrders || vm.data.fgPastWeeksOfOrders === 0) {
				settingsToSave.PROCUREMENT_FINISHED_GOODS_PAST_WEEKS_OF_ORDERS = vm.data.fgPastWeeksOfOrders;
			}
			if (vm.data.fgFutureWeeksOfOrders || vm.data.fgFutureWeeksOfOrders === 0) {
				settingsToSave.PROCUREMENT_FINISHED_GOODS_FUTURE_WEEKS_OF_ORDERS = vm.data.fgFutureWeeksOfOrders;
			}

			// Forward DOI settings
			settingsToSave.USE_FORWARD_ONLY_DEMAND_FOR_FORWARD_DOI = vm.data.useForwardOnlyDemandForForwardDOI;
			// Only save the forwardDOIWindow if the checkbox is enabled
			if (vm.data.useForwardOnlyDemandForForwardDOI && (vm.data.forwardDOIWindow || vm.data.forwardDOIWindow === 0)) {
				settingsToSave.FORWARD_DOI_WINDOW = vm.data.forwardDOIWindow;
			}

			var customerSettingsToSave = { 'EnableFGAnalytics': vm.data.isFgEnabled };

			var promises = [];
			promises.push(factorySettingService.saveFactorySettings(settingsToSave, adminConfig.factory.id));
			if (vm.isLeanDNACustomerAdmin) {
				promises.push(customerSettingService.saveCustomerSettings(customerSettingsToSave, adminConfig.factory.id));
			}

			$q.all(promises).then(function (responses) {
				var factorySettingsSuccess = responses[0] === 'Settings saved successfully';
				var customerSettingsSuccess = !vm.isLeanDNACustomerAdmin || responses[1] === 'Settings saved successfully';
				var isSuccessful = factorySettingsSuccess && customerSettingsSuccess;
				if (!run) {
					if (isSuccessful) {
						$rootScope.$emit('toast', {
							'message': responses[0],
							'success': true
						});
					} else {
						$rootScope.$emit('toast', {
							'message': 'Problem saving settings, please try again later',
							'success': false
						});
					}
				} else {
					if (isSuccessful) {
						$rootScope.$emit('toast', {
							'message': responses[0],
							'success': true
						});
						procurementService.runProcurement(vm.data.itemForDetailedLog, adminConfig.factory.id).then(function (response) {
							if (response) {
								$rootScope.$emit('toast', {
									'message': 'Analytics Engine started',
									'success': true
								});
							} else {
								$rootScope.$emit('toast', {
									'message': 'Problem running Analytics Engine, please try again later',
									'success': false
								});
							}
						});
					} else {
						$rootScope.$emit('toast', {
							'message': 'Problem saving settings, please try again later',
							'success': false
						});
					}
				}
			});
		}

		function getSnippets(curId) {
			sqlSnippetService.getSnippets(adminConfig.customer.id, 'Forecasting')
				.then(function initSnippets(snippets) {
					vm.snippets = snippets;
					vm.snippets.push(
						{
							id: -1,
							description: 'None'
						}
					);
					vm.currentSqlSnippet = vm.snippets.filter(function (snippet) {
						return snippet.id === curId;
					})[0];
				});
		}

		function safetyCalcMethodChange() {
			if (vm.data.calculationMethod === 'Standard Deviation') {
				vm.hideSafetyDays = true;
				vm.hideSafetyFactor = true;
			} else if (vm.data.calculationMethod === 'Safety Factor') {
				vm.hideSafetyDays = true;
				vm.hideSafetyFactor = false;
			} else if (vm.data.calculationMethod === 'Safety Days') {
				vm.hideSafetyDays = false;
				vm.hideSafetyFactor = true;
			} else if (vm.data.calculationMethod === 'Standard Deviation + Days') {
				vm.hideSafetyDays = false;
				vm.hideSafetyFactor = true;
			} else if (vm.data.calculationMethod === 'Safety Factor + Days') {
				vm.hideSafetyDays = false;
				vm.hideSafetyFactor = false;
			}
		}

		function excessCalcMethodChange() {
			if (vm.data.excessCalculation === 'Use Multiple of Lead Time') {
				vm.hideMaxLeadTime = false;
				vm.hideExcessPolicy = true;
			} else if (vm.data.excessCalculation === 'Use Number of Days') {
				vm.hideMaxLeadTime = true;
				vm.hideExcessPolicy = false;
			} else if (vm.data.excessCalculation === 'Use Multiple of Lead Time and Days') {
				vm.hideMaxLeadTime = false;
				vm.hideExcessPolicy = false;
			} else if (vm.data.excessCalculation === 'Amount Over Total Requirements') {
				vm.hideMaxLeadTime = true;
				vm.hideExcessPolicy = true;
			} else if (vm.data.excessCalculation === 'Amount Over 3 Times Annual Requirements') {
				vm.hideMaxLeadTime = true;
				vm.hideExcessPolicy = true;
			}
		}

		function displaySaveConfirmModal() {
			var confirmScope = $scope.$new();
			var instance = $uibModal.open({
				scope: confirmScope,
				templateUrl: '/application/f/setup/supplyChain/procurement/confirm-save-modal.html'
			});

			confirmScope.closeDialog = function() {
				instance.close();
				confirmScope.$destroy();
			};
			confirmScope.save = function() {
				vm.save();
				confirmScope.closeDialog();
			};
		}
	}
})();
